var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCodeRays({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2321 0.359816C10.8641 -0.398185 12.0951 0.119815 11.9951 1.10182L11.2891 7.99982H17.0001C17.1901 7.99989 17.3762 8.05409 17.5365 8.15609C17.6968 8.25808 17.8248 8.40364 17.9054 8.57572C17.9859 8.7478 18.0158 8.93928 17.9915 9.12773C17.9672 9.31619 17.8897 9.49381 17.7681 9.63982L7.76811 21.6398C7.13611 22.3978 5.90511 21.8798 6.00511 20.8978L6.71111 13.9998H1.00011C0.8101 13.9997 0.624039 13.9455 0.463718 13.8435C0.303398 13.7416 0.175455 13.596 0.0948709 13.4239C0.0142869 13.2518 -0.0156021 13.0604 0.00870399 12.8719C0.03301 12.6834 0.110505 12.5058 0.232114 12.3598L10.2321 0.359816Z",
    fill: "#C0AD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCodeRays);
export default __webpack_public_path__ + "static/media/editCodeRays.d2011a8d43ab1984520a985889c0c775.svg";
export { ForwardRef as ReactComponent };